<template>
  <div
    class="transition-all"
    :class="[
      itemType == 'hidden' && '-translate-x-16 opacity-0 lg:delay-[0ms]',
      itemType != 'hidden' && 'translate-x-0 opacity-100 delay-150 lg:delay-[0ms]',
    ]"
  >
    <div
      v-if="title"
      class="group rounded-medium relative flex flex-row items-center overflow-hidden transition-all"
      :class="[
        itemType == 'collapsed' && 'ease-fast-effect h-0 w-0 opacity-0 duration-200',
        itemType != 'collapsed' &&
          'ease-slow-effect h-8 w-full py-1.5 pr-2 pl-4 delay-100 duration-200',
        expandable && 'cursor-pointer',
      ]"
      @click="toggle"
    >
      <h4 class="text-label-large text-on-surface-variant grow overflow-hidden">
        {{ title }}
      </h4>
      <BaseIcon v-if="expandable" size="20">{{
        expanded ? 'collapse_all' : 'expand_all'
      }}</BaseIcon>
      <BaseStateLayer v-if="expandable" />
    </div>
    <BaseAnimatedExtend :is-extended="actualExpanded">
      <ul class="pt-1">
        <li v-for="(railItem, index) in items" :key="index">
          <CompactRailItem
            @click="emits('nav-item-clicked')"
            :type="itemType"
            :icon-name="railItem.iconName"
            :member="railItem.member"
            :team="railItem.team"
            :params="railItem.params"
            :route-name="railItem.routeName"
            :label="railItem.label"
            :bade-count="railItem.badgeCount"
          />
        </li>
      </ul>
    </BaseAnimatedExtend>
  </div>
</template>
<script lang="ts" setup>
  import { useLocalStorage } from '@vueuse/core'
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import BaseStateLayer from '../base/state-layer/BaseStateLayer.vue'
  import CompactRailItem from './CompactRailItem.vue'
  import { computed } from 'vue'
  import type { Member } from '../../models/member/member'
  import type { Team } from '../../models/team/team'
  import type { RouteParams } from 'vue-router'
  import BaseAnimatedExtend from '../base/animated-extend/BaseAnimatedExtend.vue'

  interface Props {
    id: string
    title?: string
    expandable?: boolean
    itemType: 'expanded' | 'hidden' | 'collapsed'
    items: {
      iconName?: string
      member?: Member
      team?: Team
      routeName: string
      params?: RouteParams
      label: string
      badgeCount?: number
    }[]
  }

  const { id, title, expandable = true, itemType, items } = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'nav-item-clicked'): void
  }>()

  const expanded = useLocalStorage(id + 'navigation-group-expanded', true)

  const toggle = () => {
    if (!expandable) return
    expanded.value = !expanded.value
  }

  const actualExpanded = computed(() => {
    return expanded.value
  })
</script>
